"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Storage = void 0;

require("isomorphic-unfetch");

var _app = _interopRequireDefault(require("firebase/app"));

require("firebase/storage");

var _browserOrNode = require("browser-or-node");

var _uuid = require("uuid");

var _constants = require("../constants");

var _responseBuilder = require("./responseBuilder");

var _retryFetch = require("./retryFetch");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FIREBASE_MJS_ID = 'FIREBASE_MJS_ID';
var ARWEAVE_FOLDER = 'arweave';
var headers = {
  apiKey: 'api-key'
};

var Storage = /*#__PURE__*/function () {
  function Storage() {
    var storageConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Storage);

    _defineProperty(this, "firebase", void 0);

    _defineProperty(this, "storage", void 0);

    _defineProperty(this, "apiKey", void 0);

    _defineProperty(this, "constants", void 0);

    this.constants = storageConfig.constants || {};
    this.apiKey = storageConfig.apiKey || 'anonymous';

    var mintbaseJSFirebase = _app["default"].apps.find(function (_ref) {
      var name = _ref.name;
      return name === FIREBASE_MJS_ID;
    });

    this.firebase = mintbaseJSFirebase !== null && mintbaseJSFirebase !== void 0 ? mintbaseJSFirebase : _app["default"].initializeApp(this.constants.CLOUD_STORAGE_CONFIG || _constants.CLOUD_STORAGE_CONFIG, FIREBASE_MJS_ID);
    this.storage = this.firebase.storage();
  }
  /**
   * Uploads metadata to Arweave via a cloud function
   * @param metadata metadata object
   * @returns arweave content identifier
   */


  _createClass(Storage, [{
    key: "uploadMetadata",
    value: function () {
      var _uploadMetadata = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(metadata) {
        var _headers, request, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return (0, _retryFetch.retryFetch)("".concat(_constants.CLOUD_URI, "/arweave/metadata/"), {
                  method: 'POST',
                  body: JSON.stringify(metadata),
                  headers: (_headers = {}, _defineProperty(_headers, headers.apiKey, this.apiKey || 'anonymous'), _defineProperty(_headers, 'Access-Control-Allow-Origin', '*'), _defineProperty(_headers, 'Content-type', 'text/plain'), _headers)
                });

              case 3:
                request = _context.sent;
                _context.next = 6;
                return request.json();

              case 6:
                data = _context.sent;
                return _context.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.uploadMetadata
                }));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function uploadMetadata(_x) {
        return _uploadMetadata.apply(this, arguments);
      }

      return uploadMetadata;
    }()
    /**
     * Upload file to Arweave via a cloud function
     * @param file the file to upload
     * @returns retunrns an object containing the arweave content identifier and the content type.
     */

  }, {
    key: "uploadToArweave",
    value: function () {
      var _uploadToArweave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
        var buffer, contentType, _yield$this$uploadClo, fileName, error, request, _yield$request$json, id, _contentType, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_browserOrNode.isNode) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Node environment does not yet supports uploads.'
                }));

              case 2:
                _context2.next = 4;
                return file.arrayBuffer();

              case 4:
                buffer = _context2.sent;
                contentType = file.type;
                _context2.prev = 6;
                _context2.next = 9;
                return this.uploadCloud(buffer, contentType);

              case 9:
                _yield$this$uploadClo = _context2.sent;
                fileName = _yield$this$uploadClo.data;
                error = _yield$this$uploadClo.error;

                if (!error) {
                  _context2.next = 14;
                  break;
                }

                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: error
                }));

              case 14:
                _context2.prev = 14;
                _context2.next = 17;
                return (0, _retryFetch.retryFetch)("".concat(_constants.CLOUD_URI, "/arweave/file/").concat(fileName), {
                  headers: _defineProperty({}, headers.apiKey, this.apiKey || 'anonymous')
                });

              case 17:
                request = _context2.sent;
                _context2.next = 20;
                return request.json();

              case 20:
                _yield$request$json = _context2.sent;
                id = _yield$request$json.id;
                _contentType = _yield$request$json.contentType;
                data = {
                  id: id,
                  contentType: _contentType
                };

                if (!(!id || !_contentType)) {
                  _context2.next = 26;
                  break;
                }

                throw new Error(_constants.ERROR_MESSAGES.decentralizedStorageFailed);

              case 26:
                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: data
                }));

              case 29:
                _context2.prev = 29;
                _context2.t0 = _context2["catch"](14);
                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.decentralizedStorageFailed
                }));

              case 32:
                _context2.next = 37;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t1 = _context2["catch"](6);
                return _context2.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _context2.t1.message
                }));

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 34], [14, 29]]);
      }));

      function uploadToArweave(_x2) {
        return _uploadToArweave.apply(this, arguments);
      }

      return uploadToArweave;
    }()
    /**
     * Uploads raw binary data to the cloud. This method is useful because
     * we can trigger an arweave upload via an http request with the returned file name.
     * @param buffer the raw binary data of the file to upload
     * @param contentType the content type
     * @returns the filename
     */

  }, {
    key: "uploadCloud",
    value: function () {
      var _uploadCloud = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(buffer, contentType) {
        var fileName;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_browserOrNode.isNode) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Node environment does not yet supports uploads.'
                }));

              case 2:
                _context3.prev = 2;
                fileName = (0, _uuid.v4)();

                if (this.storage) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: 'Storage is not initialized'
                }));

              case 6:
                _context3.next = 8;
                return this.storage.ref("".concat(ARWEAVE_FOLDER, "/").concat(fileName)).put(buffer, {
                  contentType: contentType
                });

              case 8:
                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  data: fileName
                }));

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](2);
                return _context3.abrupt("return", (0, _responseBuilder.formatResponse)({
                  error: _constants.ERROR_MESSAGES.uploadCloud
                }));

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 11]]);
      }));

      function uploadCloud(_x3, _x4) {
        return _uploadCloud.apply(this, arguments);
      }

      return uploadCloud;
    }()
  }]);

  return Storage;
}();

exports.Storage = Storage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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